export default "__VITE_ASSET__QPldizi2__"